import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { govCertapplyActions } from '../../../../store/actions'

import Calendar from '../../../../module/component-box/Calendar'
import moment from 'moment'

const ECDApplyPopup = (props) => {
  const [state, setState] = useState({
    count: 0,
    lastInquiry: '검색조건',
    isClick: false,
    srhFrom: '',
    srhTo: '',
  })

  const [list, setList] = useState([])

  useEffect(() => {
    // 증명서 신청 현황 조회
    props.getECDApplyListInquire()
  }, [])

  useEffect(() => {
    if (props.popupList !== null && props.popupList.length > 0) {
      const obj = {}

      props.popupList.forEach((info) => {
        obj[info.issuDt.substr(0, 6)] !== undefined
          ? obj[info.issuDt.substr(0, 6)].push(info)
          : (obj[info.issuDt.substr(0, 6)] = [info])
      })

      // 내림차순 정렬
      const newArray = Object.entries(obj).sort((a, b) => parseInt(b) - parseInt(a))
      setList(newArray)
    }
  }, [props.popupList])

  function searchList() {
    const params = {}
    // 신청 시작일(검색 조건)
    params.applBgnde = state.srhFrom
    // 신청 종료일(검색 조건)
    params.applEndde = state.srhTo

    props.getECDApplyListInquire(params)
  }

  /************************************************
   * 날짜 관련 메소드
   ************************************************/
  const onSelected = (name, value) => {
    setState({
      ...state,
      [name]: value,
    })
  }
  const selectDay = (type) => {
    const d = new Date()
    const year = d.getFullYear() // 년
    const month = d.getMonth() + 1 // 월
    const day = d.getDate() // 일

    if (type === 'W1') {
      // 1주일
      setState({
        ...state,
        lastInquiry: '최근 1주일',
        ['srhFrom']: moment(new Date(year, month, day - 7).toLocaleDateString()).format('Y-MM-DD'),
        ['srhTo']: moment(new Date(year, month, day).toLocaleDateString()).format('Y-MM-DD'),
      })
    } else if (type === 'M1') {
      // 1개월
      setState({
        ...state,
        lastInquiry: '최근 1개월',
        ['srhFrom']: moment(new Date(year, month - 1, day).toLocaleDateString()).format('Y-MM-DD'),
        ['srhTo']: moment(new Date(year, month, day).toLocaleDateString()).format('Y-MM-DD'),
      })
    } else if (type === 'M3') {
      // 3개월
      setState({
        ...state,
        lastInquiry: '최근 3개월',
        ['srhFrom']: moment(new Date(year, month - 3, day).toLocaleDateString()).format('Y-MM-DD'),
        ['srhTo']: moment(new Date(year, month, day).toLocaleDateString()).format('Y-MM-DD'),
      })
    } else if (type === 'M6') {
      // 6개월
      setState({
        ...state,
        lastInquiry: '최근 6개월',
        ['srhFrom']: moment(new Date(year, month - 6, day).toLocaleDateString()).format('Y-MM-DD'),
        ['srhTo']: moment(new Date(year, month, day).toLocaleDateString()).format('Y-MM-DD'),
      })
    } else if (type === 'Y1') {
      // 1년
      setState({
        ...state,
        lastInquiry: '최근 1년',
        ['srhFrom']: moment(new Date(year - 1, month, day).toLocaleDateString()).format('Y-MM-DD'),
        ['srhTo']: moment(new Date(year, month, day).toLocaleDateString()).format('Y-MM-DD'),
      })
    } else {
      setState({
        ...state,
        lastInquiry: '검색조건',
        ['srhFrom']: '',
        ['srhTo']: '',
      })
    }
  }

  // 증명서 신청 현황 Click Event
  const goECDApplyListTab = () => {
    // 1. 신청 현황 팝업 닫기
    props.closeECDApplyPopup()
    // 2. 전자문서지갑 Tab - 발급문서로 이동
    props.setWalletType()
  }

  return (
    <>
      {/* 알림메시지 */}
      <div className="modal-overlay">
        <div className="modal">
          <div className="modal-head">
            <h2>증명서 신청 현황</h2>
          </div>
          <div className="modal-cont">
            <div className="list-header mt10">
              <span className="total-num">
                총 <em>{props.popupList?.length > 0 ? props.popupList?.length : 0}</em>건
              </span>
              <span className="right">
                <a
                  href="#"
                  className="last-inquiry"
                  onClick={() => {
                    setState({ ...state, isClick: !state.isClick })
                  }}
                >
                  {state.lastInquiry}
                </a>
              </span>
            </div>
            {/* block 인경우 기간 검색 열림 */}
            <div className={state.isClick ? 'inquiry-detail block' : 'inquiry-detail'}>
              <div className="search-box">
                <div className="row">
                  <span className="tit">기간</span>
                  <span className="datepicker">
                    <Calendar
                      onSelect={(value) => onSelected('srhFrom', value ? moment(value).format('Y-MM-DD') : '')}
                      default={state.srhFrom}
                      title="처음날짜(신청 시작일)"
                    />
                    <span className="split">~</span>
                    <Calendar
                      onSelect={(value) => onSelected('srhTo', value ? moment(value).format('Y-MM-DD') : '')}
                      default={state.srhTo}
                      title="마지막날짜(신청 종료일)"
                    />
                  </span>
                  <span className="form-date">
                    <button type="button" onClick={() => selectDay('W1')}>
                      1주일
                    </button>
                    <button type="button" onClick={() => selectDay('M1')}>
                      1개월
                    </button>
                    <button type="button" onClick={() => selectDay('M3')}>
                      3개월
                    </button>
                    <button type="button" onClick={() => selectDay('M6')}>
                      6개월
                    </button>
                    <button type="button" onClick={() => selectDay('Y1')}>
                      1년간
                    </button>
                    <button type="button" onClick={() => selectDay('99')}>
                      초기화
                    </button>
                  </span>
                </div>
                <div className="btn-block center mt30">
                  <button type="button" className="btn-primary w70" onClick={searchList}>
                    검색
                  </button>
                </div>
              </div>
            </div>
            {list?.length > 0 ? (
              list?.map((obj, i) => {
                return (
                  <React.Fragment key={obj[0]}>
                    <p className="date-tit">{obj[0].substr(0, 4) + '년 ' + obj[0].substr(4, 6) + '월'}</p>
                    <ul className="list-type link">
                      {obj[1].map((info, index) => {
                        return (
                          <li key={info?.docKndCode ? info?.docKndCode : index}>
                            <a href="#">
                              <p className="txt">정부전자문서지갑</p>
                              <p className="tit" onClick={goECDApplyListTab}>
                                {info.docKndNm}
                              </p>
                              <p className="date">발급 {moment(info.issuDt, 'YYYYMMDDhhmmss').format('YYYY.MM.DD hh:mm')}</p>
                            </a>
                          </li>
                        )
                      })}
                    </ul>
                  </React.Fragment>
                )
              })
            ) : (
              <div className="nodata">조회 결과가 없습니다.</div>
            )}
          </div>
          <button
            type="button"
            className="modal-close"
            onClick={() => {
              props.closeECDApplyPopup()
            }}
          >
            창닫기
          </button>
        </div>
      </div>
      {/* //알림메시지 */}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    popupList: state.govcertapply.popupData,
  }
}

const actionCreators = {
  closeECDApplyPopup: govCertapplyActions.closeECDApplyPopup,
  getECDApplyListInquire: govCertapplyActions.getECDApplyListInquire,
}

export default connect(mapStateToProps, actionCreators)(ECDApplyPopup)
